import { Tab } from "@headlessui/react";

import CardRow from "components/General/CardRow";
import FormInputError from "components/General/FormInputError";
import RowPagination from "components/General/RowPagination";
import { useRowPagination } from "hooks/useRowPagination";

import ExpiredAlertView from "./ExpiredAlert";
import { useTranslation } from "react-i18next";

export default function ExpiredAlert({ alerts, alertError }) {
  const {
    rowsForDisplay: expiredAlertRows,
    rowPaginationProps: paginationProps,
  } = useRowPagination(alerts, [5, 10, 25, "all"]);
  const { t } = useTranslation();
  if (alertError) {
    return (
      <Tab.Panel>
        <CardRow
          content={
            <FormInputError
              id="ID_expiredAlertsError"
              errorMessage={t("AgentCSR-Admin-ExpiredAlert-errormessage")}
            />
          }
        />
      </Tab.Panel>
    );
  }

  if (alerts?.length === 0) {
    return (
      <Tab.Panel>
        <CardRow content={t("AgentCSR-Admin-ExpiredAlert-content")} />
      </Tab.Panel>
    );
  }

  return (
    <Tab.Panel>
      <>
        <div className="mt-4 mb-4 xl:mt-6 xl:mb-6">
          {expiredAlertRows?.map((alert) => {
            return (
              <ExpiredAlertView
                key={`expired-alert-${alert?.id}`}
                alert={alert}
              />
            );
          })}
        </div>
        <RowPagination {...paginationProps} />
      </>
    </Tab.Panel>
  );
}
